import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FaqAccordion = ({ faq = [] }) => {
  if (!faq?.length) return null;
  return (
    <div data-testid="faq-section" className="space-y-3">
      <Accordion type="single" collapsible className="space-y-3">
        {faq.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="rounded-[16px] border border-border bg-white px-5">
            <AccordionTrigger className="text-left font-medium hover:no-underline py-4">{f.question}</AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed pb-4">{f.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FaqAccordion;
